import { FirstChargeConstantStore } from '.'
import { JudgePopupType } from '../../common/util/judgePopupType'
import { judgeIsForbidPopByPageAddress } from '../../common/util/judgeIsForbidPopByPageAddress'
import Modal from '@/controller/Modal'

export type OpenModalParams = {
  store: FirstChargeConstantStore
  /** 是否登录触发 */
  isLoginTrigger: boolean
}
/** 打开首充弹窗 */
export const proxyOpenFirstChargeModal = async (params: OpenModalParams) => {
  const { store, isLoginTrigger } = params
  // 先判断用户勾选
  let isForbid = await judgeUserCheckedIsForbid(store)
  if (isForbid) {
    return
  }
  // 根据后台配置的弹窗类型来判断当前是否弹出
  isForbid = !JudgePopupType.firstCharge.run({ isLoginTrigger })
  if (isForbid) {
    return
  }
  // 根据当前页面地址判断是否禁用弹窗
  isForbid = judgeIsForbidPopByPageAddress(isLoginTrigger)
  if (isForbid) {
    return
  }
  // 打开弹窗，关暂停，需要等弹窗关闭时，才结束暂停
  await new Promise((resolve) => {
    // 打开弹窗
    Modal.open('firstChargeConstant').then((context) => {
      //重点,环境监听,只能使用$once,不然会重复监听越来越多的内容
      context.$once('modal:close', () => {
        resolve(undefined)
      })
    })
  })
}

/** 判断用户是否勾选了禁用弹框 */
const judgeUserCheckedIsForbid = (store: FirstChargeConstantStore) => {
  // 后台禁用本项|勾选永不提示|勾选本次不提示|业务层面要求只弹一次,任何一个为true则不再弹框
  const { isNeverRemind, isTodayNotRemind } = store
  // 后台配置的,不显示弹窗
  const { isServerDisabled } = store
  if (isNeverRemind.get() || isTodayNotRemind.get() || isServerDisabled) {
    return true
  } else {
    return false
  }
}
